var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isBooked && !_vm.isSlotFromInPast)?_c('div',{class:_vm.isSelected
      ? _vm.$style.tile_selected
      : _vm.isSlotFromInPast
      ? _vm.$style.tile_disabled
      : _vm.$style.tile,on:{"click":_vm.toggleSelect}},[_c('p',{class:_vm.isSelected
        ? _vm.$style.timeText_selected
        : _vm.isSlotFromInPast
        ? _vm.$style.timeText_disabled
        : _vm.$style.timeText},[_vm._v(" "+_vm._s(_vm.localtimeSlot)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }